module.exports = __webpack_public_path__ + "img/logo-company.e8a1370b.png";